const isMobileScreen = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(max-width: 700px)').matches;

export default isMobileScreen;
